import React, { useEffect, useState } from "react";

import Web3 from "web3";
import Web3Modal from "web3modal";

// nft.storege import
import * as fs from "fs";
import { NFTStorage, File } from "nft.storage";
import { toast } from "react-hot-toast";

// Stylesheet
import "./MetaData.css";
// Material UI Icons
import CloseIcon from "@mui/icons-material/Close";
import DragDrop from "../../../../components/dragDrop/DragDrop";

const apiKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweDgwMjlFMGVFNWVGRmQxZjhGNEI2MjRDODUyQjYwMGFjMkMwNDU2M2UiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTYzNTkyMDQwNDI5NSwibmFtZSI6ImRlbW9ORlQifQ.2RQP_HZCYI6NJLQOSnQWTw-lQnRaWgWN5gkxIOccxgw";
const client = new NFTStorage({ token: apiKey });

function MetaData({
  selectedFile,
  data,
  setData,
  setSelectedFile,
  isSubmited,
}) {
  const [tags, setTags] = useState([]);
  const [isImage, setImageType] = useState(true);
  const [uploadImage, setUploadImage] = useState("");
  const [uploadVideo, setVideo] = useState("");
  // nft.store trial

  // async function onchange(e) {
  //   try {

  //   const file=e.target.files[0];
  //   console.log(file.type);
  //     const f=new File([file], `${file.name}`, {
  //       type: file.type,
  //     });
  //     const cid=await client.storeBlob(file);
  //     const md=await client.store({
  //       name: "hhhh",
  //       description: "fkkojrf",

  //       image: f
  //     });
  //     console.log(f);
  //     const url = `https://ipfs.infura.io/ipfs/${md.ipnft}/metadata.json`;
  //     //const url=md;
  //     //const cid=await client.storeBlob(file);

  //     console.log(cid);
  //     //setFileUrl(url);
  //     console.log(md.embed());
  //     console.log(md.data);
  //     console.log(url);
  //     return url;
  //   } catch (error) {
  //     console.log("Error uploading file:", error);
  //   }
  // }
  useEffect(() => {
    setData({ ...data, tags: tags });
  }, [tags]);

  return (
    <div className="metadata">
      <div className="form-half">
        {/* <DragDrop className="form-left" />  Just for now*/}
        <div
          className={
            "form-left" + (isSubmited && !selectedFile ? " errorField" : "")
          }
        >
          {isImage && uploadImage && (
            <img style={{ zIndex: 5 }} id="imgSelection" src={uploadImage} />
          )}
          {!isImage && uploadVideo && (
            <video
              style={{ zIndex: 5 }}
              src={uploadVideo}
              preload="metadata"
            ></video>
          )}
          <input
            type="file"
            name=""
            id=""
            style={{ zIndex: "20" }}
            className="form-left"
            onChange={async (e) => {
              const file = e.target.files[0];
              if (file.size <= 1024 * 1024 * 100) {
                setSelectedFile(file);
                var extension = file.type;
                console.log(file.type);
                var reader = new FileReader();
                reader.onload = async (e) => {
                  var result = reader.result;
                  if (extension.indexOf("image") > -1) {
                    setImageType(true);
                    setUploadImage(result);
                    if (extension === "image/gif")
                      setData({ ...data, imageType: "gif" });
                    else setData({ ...data, imageType: "image" });
                  } else {
                    setImageType(false);
                    setVideo(result);
                    setData({ ...data, imageType: "video" });
                  }
                };
                reader.readAsDataURL(file);
              } else {
                toast.error("File size should be max 100MB.");
              }
            }}
          />
          {isImage && uploadImage ? null : (
            <span
              style={{
                zIndex: 1,
                textAlign: "center",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              Drop or Browse <br /> File Here
              <br /> <br /> <br />{" "}
              <small style={{ color: "#d3aa4b", fontSize: "10px" }}>
                (PNG,GIF,WEBP,MP4 <br /> or MP3 100Maxmb)
              </small>
            </span>
          )}
        </div>
        <div className="form-right">
          <input
            type="text"
            className={isSubmited && !data.name ? " errorField" : ""}
            placeholder="Add Title"
            value={data.name}
            onChange={(e) => {
              setData({ ...data, name: e.target.value });
            }}
          />
          <textarea
            rows="7"
            value={data.description}
            onChange={(e) => {
              setData({ ...data, description: e.target.value });
            }}
            placeholder="Add Description"
            className={
              "description" +
              (isSubmited && !data.description ? " errorField" : "")
            }
          ></textarea>
        </div>
      </div>
      <br />

      <label>
        Add External Link
        <span className="yellow">
          (You can add your external links like twitter/opensea/website etc...)
        </span>
        <input
          onChange={(e) => {
            setData({ ...data, url: e.target.value });
          }}
          type="url"
          placeholder="Add URL"
        />
      </label>
      <br />

      <label>
        Add Tags
        <span className="yellow">(Max : 5)</span>
        <br />
        <input
          type="text"
          className="input-tags"
          name=""
          id=""
          disabled={tags && tags.length === 5}
          placeholder="Add Tags"
          onKeyPress={(event) => {
            if (event.key === "Enter" && tags.length < 5) {
              setTags([...tags, event.target.value]);
              event.target.value = "";
            }
          }}
          autofocus
        />
      </label>
      <div className="tags">
        {tags &&
          tags.map((tag) => (
            <p className="tag">
              {tag}
              <CloseIcon
                className="tag-icon"
                size="16"
                onClick={() => {
                  setTags([...tags.filter((word) => word !== tag)]);
                  setData({ ...data, tags: tags });
                }}
              />
            </p>
          ))}
      </div>
    </div>
  );
}

export default MetaData;
